import React from "react";
import "./CustomTableWithColors.style.scss";

const CustomTableWithColors = ({ data }) => {
  const heading = ["Security Holding", "Weight (%)"];
  return (
    <table className="customTableWithClr">
      <thead>
        <tr>
          <th></th>
          {heading.map((e, i) => (
            <th
              key={`${e}-${i}`}
              className={`${i === 0 ? "customTableWithClr_txt_alignLeft" : ""}`}
            >
              {e}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((e, i) => (
          <tr key={`table-${i}`} className="customTableWithClr_tr">
            <td style={{ backgroundColor: `${e[0]}` }}></td>
            <td className="customTableWithClr_txt_alignLeft">{e[1]}</td>
            <td>{e[2]}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default CustomTableWithColors;



// WEBPACK FOOTER //
// ./src/components/pages/Create_portfolio_by_Advisor/model_portfolio/customTableWithColors/CustomTableWithColors.jsx